<template lang="pug">
  
</template>

<script>

export default {
	name: 'Zoom',

	componentOptions: {
		actions: [
			[
				{
					name: 'Zoom in',
					iconClass: 'mdi mdi-plus',
					action: 'zoomIn'
				},
				{
					name: 'Zoom out',
					iconClass: 'mdi mdi-minus',
					action: 'zoomOut'
				}
			],
			[
				{
					name: 'Zoom por seleção',
					iconClass: 'mdi mdi-shape-rectangle-plus',
					action: 'boxZoom'
				}
			],
			[
				{
					name: 'Zoom inicial',
					iconClass: 'mdi mdi-home',
					action: 'initialZoom'
				}
			]
		]
	},

	methods: {

		zoomIn () {
			this.$bus.$emit('mapa.zoomIn');
		},

		zoomOut () {
			this.$bus.$emit('mapa.zoomOut');
		},

		initialZoom () {
			this.$bus.$emit('mapa.initialZoom');
		},

		boxZoom () {
			this.$bus.$emit('mapa.boxZoom');
		}
	}
};

</script>


// WEBPACK FOOTER //
// Zoom.vue?1651e4b9